// service统一出口
import { useStore } from '@/store';
import SXYXRequest from './request';
import { BASE_URL, TIME_OUT } from './request/config';
import sessionCache from '@/utils/sessionCache';
import { UserConstants } from '@/models/constant';
import { UserActionTypes } from '@/store/modules/user/action-types';
const sxyxRequest = new SXYXRequest({
  baseURL: BASE_URL + '/v1',
  timeout: TIME_OUT,
  // showLoading: true, // 全局配置显示loading
  interceptors: {
    requestInterceptor: config => {
      // console.log('单个实例-请求成功的拦截')
      // 携带token的拦截
      const token = sessionCache.getCache(UserConstants.TOKEN);
      if (token && config.headers) {
        config.headers.Authorization = token;
      }
      return config;
    },
    requestInterceptorCatch: err => {
      // console.log('单个实例-请求失败的拦截')
      console.log(err);
      return err;
    },
    responseInterceptor: response => {
      console.log('单个实例-响应成功的拦截');
      console.log('response---', response);
      const {
        status,
        data,
        statusText
      } = response;
      if (status === 200) {
        if (data.errorCode === 200) {
          return response;
        } else {
          ElMessage.error(data.message);
        }
      }
      return response;
    },
    responseInterceptorCatch: err => {
      const {
        status,
        data,
        statusText
      } = err.response;
      if (status && status !== 200) {
        ElMessage.error(data.message || statusText);
      }
      if (status && status === 401) {
        useStore().dispatch(UserActionTypes.ACTION_LOGIN_OUT);
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
      return err.response;
    }
  }
});
export default sxyxRequest;